<template>
  <v-container fluid>
    <base-material-card
      color="ocean"
      class="px-5 py-3 mb-5"
    >
      <template v-slot:heading>
        <div class="display-2 font-weight-light">
          {{ $t('explanation.system-explanation') }}
        </div>
        <div class="subtitle-1 font-weight-light">
          {{ $t('explanation.system-description') }}
        </div>
      </template>

      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <base-material-card
              color="info"
              class="px-5 py-3 mb-3"
            >
              <template v-slot:heading>
                <div class="headline font-weight-light mb-2">
                  {{ $t('explanation.update-management') }}
                </div>
              </template>
              <v-card-text>
                <v-img
                  src="@/assets/explanation/orgaiztion.png"
                  alt="更新會管理"
                  class="mb-4"
                  contain
                  height="150"
                ></v-img>
                <h4>{{ $t('explanation.update-management') }}</h4>
                <v-list-item
                  v-for="(item, i) in updateManagementFeatures"
                  :key="i"
                  class="pa-0"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon color="success">mdi-check-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(item) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
            </base-material-card>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <base-material-card
              color="success"
              class="px-5 py-3 mb-3"
            >
              <template v-slot:heading>
                <div class="headline font-weight-light mb-2">
                  {{ $t('explanation.import-export-transcript') }}
                </div>
              </template>
              <v-card-text>
                <v-img
                  src="@/assets/explanation/import-export.png"
                  alt="匯入謄本/匯出謄本"
                  class="mb-4"
                  contain
                  height="150"
                ></v-img>
                <h4>{{ $t('explanation.import-export-transcript') }}</h4>
                <v-list-item
                  v-for="(item, i) in importExportFeatures"
                  :key="i"
                  class="pa-0"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon color="success">mdi-check-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(item) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
            </base-material-card>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <base-material-card
              color="warning"
              class="px-5 py-3 mb-3"
            >
              <template v-slot:heading>
                <div class="headline font-weight-light mb-2">
                  {{ $t('explanation.export-agreement') }}
                </div>
              </template>
              <v-card-text>
                <v-img
                  src="@/assets/explanation/agree.png"
                  alt="匯出同意書"
                  class="mb-4"
                  contain
                  height="150"
                ></v-img>
                <h4>{{ $t('explanation.export-agreement') }}</h4>
                <v-list-item
                  v-for="(item, i) in exportAgreementFeatures"
                  :key="i"
                  class="pa-0"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon color="success">mdi-check-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(item) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
            </base-material-card>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="12">
            <base-material-card
              color="secondary"
              class="px-5 py-3 mb-3"
            >
              <template v-slot:heading>
                <div class="title font-weight-light mb-2">
                  {{ $t('explanation.template-management') }}
                </div>
              </template>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <h4>{{ $t('explanation.template-features') }}</h4>
                    <v-list-item
                      v-for="(item, i) in templateManagementFeatures"
                      :key="i"
                      class="pa-0"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon color="success">mdi-check-circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t(item) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-img
                      src="@/assets/images/largeicon01.png"
                      alt="模板管理"
                      contain
                      height="200"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-card-text>
            </base-material-card>
          </v-col>
        </v-row> -->
      </v-card-text>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: 'SystemExplanation',
  
  data: () => ({
    updateManagementFeatures: [
      '匯入正式謄本 自動生成',
      '自動土地建物計算比例',
      '匯出更新會成員',
      '自動更新會成員(VIP)',
      '每更新會3000點 優惠期間免費'
      
    ],
    importExportFeatures: [
      '批量轉換謄本',
      '自動土地建物計算比例',
      '自動更新會成員',
      '多種格式顯示',
      '一筆所有權人7點'
    ],
    exportAgreementFeatures: [
      '根據不同縣市匯出',
      '匯出事業概要',
      '匯出組織更新會',
      '匯出事業計畫同意書',
      '優惠中 目前免費匯出'
    ],
    templateManagementFeatures: [
      '上傳模板',
      '下載模板',
      '重置模板',
      '自定義模板',
    ],
  }),
  methods: {
    ...mapMutations(["setTitle"]),
  },
  mounted() {
    this.setTitle(this.$i18n.t("explanation.system-explanation"));
  },
}
</script>

<style scoped>
.v-list-item {
  min-height: 32px;
}
</style>
